import styled from 'styled-components'

import { CommonTextProps, commonTextStyle, } from '../utils'

export default styled.p<CommonTextProps>`
  margin: 0;
  ${ commonTextStyle }
`
